<!--定场数据-->
<template lang="pug">
  div
    el-dialog(
      title="定场管理"
      class="el-dialog-custom"
      top="3vh"
      width="95%"
      :visible.sync="vaisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="closeDialog(false)"
    )
      el-card(shadow="never")
        div.clearfix(slot="header")
          span.fontStyle 定场情况及场地收入
        div.container
          div.dateContainer
            div(style="text-align: right; flex-shrink: 0;") 选择日期:&nbsp;
            div.el-form-item__label
              el-date-picker(
                type="date"
                v-model="queryParams.startDate"
                placeholder="请选择日期"
                @change="chooseDateRange"
              )
            div(style="flex-shrink: 0;") 选择场地属性:&nbsp;
            div.el-form-item__label
              el-select(v-model="queryParams.type" @change="getPlacetypeChange" clearable placeholder="请选择场地属性")
                el-option(v-for="item in placeTypeArray" :key="item.key" :label="item.value" :value="item.key")
          div.iconContainer
            div.el-form-item__label 后台预定
            div.iconFour
            div.el-form-item__label 客户预定
            div.iconOne
            div.el-form-item__label 可预定
            div.iconTwo
            div.el-form-item__label 不可预定
            div.iconThree
        div(style="display: flex; margin: 10px 0px;")
          div.el-form-item__label(style="margin-right: 50px;") 场地收入：{{ dataObject.amount === 0 ? 0 : ( dataObject.amount || '--') }} 元
          div.el-form-item__label 场地总收入：{{ dataObject.totalAmount === 0 ? 0 : ( dataObject.totalAmount || '--') }} 元
        el-table(:data="dataObject.itemList" style="width: 100%;" v-loading="loading")
          el-table-column(label="时间" align="center" width="200")
            template(slot-scope="scope") {{ scope.row.startTime }}-{{ scope.row.endTime }}
          el-table-column(v-for="(item, index) of headTable" :key="index" :label="item.week" align="center")
            template(v-if="item.children && item.children.length")
              el-table-column(v-for="(headtitle, index) in item.children" :key="index" :label="headtitle.label" align="center")
                template(slot-scope="scope")
                  div(v-for="(i, index) of scope.row.itemDateList" :key="index")
                    div(v-if="i.type == item.type && i.number == headtitle.number")
                      //- 后台预订(黄)
                      div.labelPc(v-if="i.status == 1 && i.source == 1" @click.stop="cancelAppoint(scope.row, i)" @contextmenu.prevent="addTip(scope.row, i)")
                        span {{ i.price ? ('￥' + i.price) : ''}}
                        span(v-if="i.remark") ：{{ i.remark }}
                        span(v-else style="color: #CDCDCD;") ：(点击鼠标右键输入备注)
                      //- 客户预订(绿)
                      div.labelDot(v-if="i.status == 1 && i.source != 1" @click.stop="cancelAppoint(scope.row, i)" @contextmenu.prevent="addTip(scope.row, i)")
                        span {{ i.price ? ('￥' + i.price) : ''}}
                        span(v-if="i.remark") ：{{ i.remark }}
                        span(v-else style="color: #CDCDCD;") ：(点击鼠标右键输入备注)
                      //- 可预订(灰)
                      div.labelCan(v-if="i.status == 2" @click.stop="appointField(scope.row, i)" @contextmenu.prevent="addTip(scope.row, i)")
                        span {{ i.price ? ('￥' + i.price) : ''}}
                        span(v-if="i.remark") ：{{ i.remark }}
                        span(v-else style="color: #CDCDCD;") ：(点击鼠标右键输入备注)
                      //- 不可预定(深灰)
                      div.labelNo(v-if="i.status == 0")
                        span {{ i.price ? ('￥' + i.price) : ''}}
                        span(v-if="i.remark") ：{{ i.remark }}
                        span(v-else style="color: #CDCDCD;") ：(点击鼠标右键输入备注)
                      //- (未知)
                      div(v-if="!i.status || (i.status != 0 && i.status != 1 && i.status != 2)") {{ i.price ? ('￥' + i.price) : ''}}
      span.dialog-footer(slot="footer")
        el-button(@click="closeDialog(false)") 返回

    el-dialog(title="订场信息" :visible.sync="dialogVisible" append-to-body)
      div.appointInfo
        div 姓名: &nbsp;&nbsp;{{ formData.memberName }}
        div 账号: &nbsp;&nbsp;{{ formData.mobile }}
        div 会员类型: &nbsp;&nbsp;{{ formData.memberTypeName }}
        div 支付金额: &nbsp;&nbsp;{{ `￥&nbsp;${Number(formData.payAmount)}&nbsp;元` }}
      span.dialog-footer(slot="footer")
        el-button(type="primary" @click="dialogVisible = false") 确 定

    el-dialog(title="添加备注" :visible.sync="showTip" width="30%" top="30vh" append-to-body close-on-click-modal @closed="addTipDialogClosed")
      div.tip-dialog-box
        el-form(:model="tipForm" :rules="tipFormRules" ref="tipFormRef" label-suffix=":" inline)
          el-form-item(label="备注内容" prop="remark" style="width: 100%;")
            el-input(v-model="tipForm.remark" maxlength="15" style="width: 100%;" placeholder="备注长度不能超过15个字符" clearable)
      span.dialog-footer(slot="footer")
        el-button(type="primary" @click="confirmAddTip") 确 定

</template>

<script>
import { formTime } from '@/util/dateUtils'

export default {
  name: 'ReserveData',
  props: {
    vaisible: {
      type: Boolean,
      default: false
    },
    placeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      placeTypeArray: [], // 场地属性集合列表
      placeNoArray: [], // 场地号集合列表
      queryParams: { // 查询参数
        type: '',
        number: '',
        startDate: '',
        endDate: '',
        // rangTime: []
      },
      loading: false,
      min: '',
      pickeroptions: {
        onPick: ({ maxDate, minDate }) => {
          this.min = minDate && minDate.getTime() // 将第一个选中的日期赋值给 this.min
          // 如果选择了时间段，则清空 this.min
          if (maxDate) {
            this.min = ''
          }
        },
        disabledDate: time => {
          let seven = 13 * 24 * 60 * 60 * 1000
          // 如果开始日期已选中，则返回需求中需要禁用的时间
          if (this.min !== '') {
            return (
              time.getTime() > this.min + seven ||
              time.getTime() < this.min - seven
            )
          } else {
            return false
          }
        }
      },
      dataObject: {
        itemList: [
          {
            startTime: '',
            endTime: '',
            itemDateList: [
              // { date: '8月31日', status: 1 },
              // { date: '8月28日', status: 0 },
              // { date: '8月27日', status: 1 },
              // { date: '8月29日', status: 1 },
              // { date: '8月30日', status: 0 },
              // { date: '9月1日', status: 1 },
              // { date: '9月2日', status: 0 }
            ]
          },
          {
            startTime: '',
            endTime: '',
            itemDateList: [
              // { status: 0 },
              // { status: 1 },
              // { status: 0 },
              // { status: 1 },
              // { status: 0 },
              // { status: 1 },
              // { status: 0 }
            ]
          }
        ]
      }, // 存放定场数据
      headTable: [],
      weekConvert: {
        '0': '日',
        '1': '一',
        '2': '二',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六'
      },
      dialogVisible: false,
      formData: {},
      // 添加备注
      showTip: false,
      tipForm: {
        placeItemId: '',
        remark: ''
      },
      tipFormRules: {
        remark: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback()
              } else if (!/^[A-Za-z0-9\u4e00-\u9fa5 .]+$/.test(value)) {
                callback(new Error('备注内容仅支持英文字母、中文字符、数字、空格'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getPlaceType()
    this.setFixedTime() // 修改默认查当天
  },
  methods: {
    // 升级表头（以场地类型为纬度）
    getHead (list) {
      this.headTable = []
      let tempArr = []
      if (this.queryParams.type) {
        tempArr = this.placeTypeArray.filter(item => {
          return item.key == this.queryParams.type
        })
      } else {
        tempArr = this.placeTypeArray
      }
      tempArr.map(item => {
        this.headTable.push({
          type: item.key,
          week: item.value,
          children: []
        })
      })
      let uniqueArr = list.filter((item, index) => {
        return list.findIndex(t => t.type === item.type && t.number === item.number) === index
      })
      uniqueArr.map(item => {
        this.headTable.map(title => {
          if (title.type == item.type) {
            title.children.push({
              label: `${title.week}${item.number}`,
              number: item.number
            })
          }
        })
      })
    },
    // 动态获取头部方法
    getHeadData () {
      this.headTable = []
      let start = new Date(this.queryParams.rangTime[0])
      let end = new Date(this.queryParams.rangTime[1])
      // 默认将初始第一天放入
      this.headTable.push({
        dateStr:
          start.getFullYear() + '-' + (start.getMonth() + 1).toString().padStart(2, '0') + '-' + start.getDate().toString().padStart(2, '0'),
        dateTime: start.getMonth() + 1 + '月' + start.getDate() + '日',
        week: '周' + this.weekConvert[start.getDay().toString()]
      })
      // 判断差距多少天
      let days = (end - start) / (24 * 3600 * 1000)
      for (let i = 1; i <= days; i++) {
        let dateObject = new Date(start)
        dateObject.setDate(start.getDate() + i)
        this.headTable.push({
          dateStr: dateObject.getFullYear() + '-' + (dateObject.getMonth() + 1).toString().padStart(2, '0') + '-' + dateObject.getDate().toString().padStart(2, '0'),
          dateTime: dateObject.getMonth() + 1 + '月' + dateObject.getDate() + '日',
          week: '周' + this.weekConvert[dateObject.getDay().toString()]
        })
      }
    },
    // 获取约场地定场数据列表
    getPlaceOrderData () {
      var paramsa = { ...this.queryParams }
      paramsa.startDate = formTime(paramsa.startDate)
      // paramsa.endDate = formTime(paramsa.rangTime[1])
      // paramsa.rangTime = undefined
      this.loading = true
      this.$http({
        url: this.$http.adornUrl(`/bp-book-places/ordered-data/${this.placeId}`),
        method: 'post',
        data: paramsa
      })
        .then(data => {
          if (data && data.code === 0) {
            this.dataObject = data.data
            this.loading = false
          }
        })
    },
    // 确定选择日期触发事件
    chooseDateRange (val) {
      // this.queryParams.startDate = formTime(this.queryParams.startDate)
      this.getPlaceNoData()
      this.getPlaceOrderData()
    },
    // 默认七天更新（默认查当天）
    setFixedTime () {
      this.queryParams.startDate = new Date()
      // let endTime = new Date()
      // endTime.setTime(startTime.getTime() + 3600 * 1000 * 24 * 6)
      // this.queryParams.rangTime.push(startTime)
      // this.queryParams.rangTime.push(endTime)
      // 动态改变头部
      this.getPlaceOrderData()
    },
    // 场地属性改变
    getPlacetypeChange () {
      this.getPlaceNoData()
      this.getPlaceOrderData()
    },
    // 根据约场地属性动态查询场地号列表(新表头)
    getPlaceNoData () {
      this.queryParams.number = '' // 将场地好置空
      this.$http({
        url: this.$http.adornUrl(`/bp-book-places/item-list/${this.placeId}`),
        method: 'get',
        params: this.$http.adornParams({
          placeId: this.placeId,
          type: this.queryParams.type,
          openDate: formTime(this.queryParams.startDate)
        })
      })
        .then(data => {
          if (data && data.code === 0) {
            this.placeNoArray = data.data
            this.getHead(data.data)
            let placeSet = new Set()
            this.placeNoArray.forEach(ele => {
              placeSet.add(ele.number)
            })
            this.placeNoArray = [...placeSet]
          }
        })
    },
    // 获取约场地属性列表
    getPlaceType () {
      this.$http({
        url: this.$http.adornUrl(`/bp-book-places/type-list/${this.placeId}`),
        method: 'get',
        params: this.$http.adornParams({ placeId: this.placeId })
      })
        .then(data => {
          if (data && data.code === 0) {
            this.placeTypeArray = data.data
            this.getPlaceNoData()
          }
        })
    },
    // 占场
    appointField (row, i) {
      // 0 不可预定
      // 1 已预订
      // 2 可预定
      // 3 我的预定
      let params = i
      params.bookPlaceId = this.placeId
      params.orderDate = i.date
      params.startTime = row.startTime
      params.endTime = row.endTime === '24:00' ? '23:59' : row.endTime
      this.$confirm('是否占用该场地？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl('/bp-book-places/occupancy'),
            method: 'post',
            data: params
          })
            .then(e => {
              if (e.code === 0) {
                this.$message.success('操作成功！')
                this.getPlaceOrderData()
              }
            })
        })
        .catch(() => {
          this.$message.info('已取消！')
        })
    },
    cancelAppoint (row, i) {
      if (i.status == 1 && i.source == 1) { // 已预定且是管理端预定
        this.$confirm('该场地为后台占用！', '定场信息', {
          confirmButtonText: '取消占场',
          cancelButtonText: '关闭',
          type: 'warning'
        })
          .then(() => {
            this.$http({
              url: this.$http.adornUrl('/bp-book-places/cancelOccupancy?orderItemId=' + i.orderItemId),
              method: 'get'
            }).then(e => {
              if (e.code === 0) {
                this.$message.success('取消占场成功！')
                this.getPlaceOrderData()
              }
            })
          })
          .catch(() => {
            this.$message.info('已取消！')
          })
      } else if (!i.source) { // 小程序端占用
        this.dialogVisible = true
        // 获取占用信息
        this.$http({
          url: this.$http.adornUrl('/bp-book-places/getOrderInfo?orderItemId=' + i.orderItemId),
          method: 'get'
        })
          .then(res => {
            if (res.code === 0) {
              this.formData = res.data
              this.formData.memberTypeName = this.formData.memberType == 1 ? '注册会员' : (this.formData.memberType == 2 ? '初始会员' : '荣誉会员')
            }
          })
      }
    },
    closeDialog (val) {
      this.$emit('update:vaisible', val)
    },
    // 打开添加备注Dialog
    addTip (row, i) {
      this.showTip = true
      this.tipForm.placeItemId = i.placeItemId
      this.tipForm.remark = i.remark || ''
    },
    // 确认添加备注
    confirmAddTip () {
      this.$refs.tipFormRef.validate(valid => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/bp-book-places/updateItemRemark/${this.placeId}`),
            method: 'post',
            data: this.tipForm
          })
            .then(data => {
              if (data && data.code === 0) {
                this.$message.success('修改备注成功！')
                this.showTip = false
                this.addTipDialogClosed()
                this.getPlaceOrderData()
              }
            })
        }
      })
    },
    // 备注Dialog表单重置
    addTipDialogClosed () {
      this.$refs.tipFormRef.resetFields()
    }
  }
}
</script>

<style scoped>
.el-dialog-custom {
  overflow: hidden !important;
}

.el-dialog-custom /deep/ .el-dialog__body {
  height: 73vh;
  overflow: auto;
}

.el-dialog-custom /deep/ .el-dialog__footer {
  border-top: 1px solid #E9E9E9;
}

.labelPc {
  background: yellow;
  height: 23px;
  width: 100%;
}

.labelDot {
  background: #02b90d;
  height: 23px;
  width: 100%;
}

.labelCan {
  background: #f5f5f5;
  height: 23px;
  width: 100%;
}

.labelNo {
  height: 23px;
  width: 100%;
  background: rgb(189, 189, 189);
}

.fontStyle {
  font-weight: bold;
  font-size: 18px;
}

.container {
  display: flex;
  justify-content: space-between;
}

.dateContainer {
  width: 40%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.iconContainer {
  width: 35%;
  display: flex;
  justify-content: flex-end;
}

.iconOne {
  width: 40px;
  height: 40px;
  background: #02b90d;
  margin-right: 40px;
}

.iconTwo {
  width: 40px;
  height: 40px;
  background: #f5f5f5;
  border: 1px solid silver;
  margin-right: 40px;
}

.iconThree {
  width: 40px;
  height: 40px;
  background: rgb(189, 189, 189);
  /* border: 1px solid rgb(117, 117, 117); */
}

.iconFour {
  width: 40px;
  height: 40px;
  background-color: yellow;
  margin-right: 40px;
}

.appointInfo {
  width: 100%;
  margin-left: 100px;
  font-size: 16px;
  line-height: 40px;
}

.tip-dialog-box /deep/ .el-form-item {
  display: flex;
}

.tip-dialog-box /deep/ .el-form-item__content {
  flex: 1;
}
</style>
